<mat-form-field class="me-3">
  <input
    matInput
    placeholder="Search For a Unit"
    name="unitsControl"
    [matAutocomplete]="mutualFundAuto"
    [formControl]="unitsControl"
    [(ngModel)]="mutualFund.unit"
    (blur)="checkSelection()"
  />
  <mat-autocomplete #mutualFundAuto="matAutocomplete">
    @for (unit of filteredUnits; track unit) {
      <mat-option [value]="unit.id">
        {{ unit.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
<mat-form-field class="me-3">
  <input
    matInput
    placeholder="Start Date"
    [matDatepicker]="startPicker"
    [(ngModel)]="mutualFund.start"
  />
  <mat-datepicker-toggle matSuffix [for]="startPicker" />
  <mat-datepicker #startPicker />
</mat-form-field>
<mat-form-field class="me-3">
  <input
    matInput
    placeholder="End Date"
    [matDatepicker]="endPicker"
    [(ngModel)]="mutualFund.end"
  />
  <mat-datepicker-toggle matSuffix [for]="endPicker" />
  <mat-datepicker #endPicker />
</mat-form-field>
<button
  type="button"
  mat-raised-button
  color="accent"
  class="mx-auto"
  [disabled]="!mutualFund.unit"
  (click)="getMfReport()"
>
  Download
</button>
@if (mutualFundData.data) {
  <kendo-grid
    class="col-12 mt-3 usage-grid"
    [kendoGridBinding]="mutualFundData.data"
    [height]="600"
    [selectable]="true"
    [navigable]="true"
  >
    @for (col of mutualFundData['header']; track col) {
      <kendo-grid-column [field]="col.DataField" [title]="col.Label" />
    }
  </kendo-grid>
}
